import React from "react";
import TypewriterText from "./TypewriterText";

/**
 * HeroWithVideoBackground
 * Responsive, accessible hero component with a full-bleed video background.
 *
 * Usage:
 * <HeroWithVideoBackground
 *   videoSrc="/media/hero.mp4"
 *   poster="/images/hero-poster.jpg"
 *   logo={<img src="/logo.svg" alt="Brand" className="h-8" />}
 *   ctaText="Connect"
 *   onConnect={() => console.log('connect')}
 * />
 */

export default function HeroWithVideoBackground({
  videoSrc = "/test.mp4",
  poster,
  logo = '/logo.png',
  ctaText = "Connect",
  onConnect,
  className = "",
}) {
  const [videoLoaded, setVideoLoaded] = React.useState(false);

  return (
    <header className={`relative w-full h-[70vh] md:h-[100vh] max-h-screen min-h-[480px] bg-black overflow-hidden ${className}`}>
      {/* Background video - covers the full hero */}
      <video
        aria-hidden="true"
        playsInline
        muted
        loop
        autoPlay
        poster={poster}
        onLoadedData={() => setVideoLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover -z-10 transition-opacity duration-1000 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      {/* Static Poster Image Fallback (Higher priority than video poster for manual control if needed) */}
      {!videoLoaded && poster && (
        <div
          className="absolute inset-0 w-full h-full object-cover -z-10 animate-pulse-slow"
          style={{
            backgroundColor: "black",
            // backgroundImage: `url(${poster})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      )}

      {/* Overlay to darken the video and improve text contrast */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/70 -z-0"
      />

      {/* Top bar (logo left, CTA right) */}


      {/* Centered content */}
      <div className="relative z-10 flex items-center justify-center h-[calc(100%-72px)]">
        <div className="text-center px-6 sm:px-8 lg:px-0 w-[90%] md:max-w-4xl">
          {/* <p className="sr-only">Hero: Connecting potential to opportunity</p> */}

          <h1 className="text-white font-bold leading-tight tracking-tight text-[27px] sm:text-[36px] md:text-5xl lg:text-6xl">
            <span className="block">
              {/* <TypewriterText
                className="mr-4 font-bold"
                text="CONNECTING"
                speed={80}     // typing speed in ms
                loop={true}    // set false if you want it to stop after one time
              /> */}
              <span className="mx-2 md:mx-4"> CONNECTING</span>
              <span className="font-light block md:inline">POTENTIAL</span>
            </span>
            <span className="block font-light  mt-2 ">WITH
              {/* <strong className="font-bold">OPPORTUNITY</strong> */}
              <TypewriterText
                className="ml-4 font-bold"
                text="OPPORTUNITY"
                speed={80}     // typing speed in ms
                loop={true}    // set false if you want it to stop after one time
              />
            </span>
          </h1>

          {/* <p className="mt-6 text-white/80 text-[18px] sm:text-[24px] max-w-2xl mx-auto font-light">
            Build meaningful connections at scale <br />discover talent, opportunities and partnerships.
          </p> */}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 pointer-events-none bg-gradient-to-t from-[#000]/100 to-transparent z-0" />
    </header>
  );
}
